<template>
  <div class="app-his-tab">
    <!-- SETA O STATUS DA TELA -->
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <!-- SETA OS DADOS DA TELA -->
    <div v-else>
      <App-Tabela :data-time='time'
      :cpntApiRouter="route"
      :cpntApiMethods="method"
      :cpntApiWhere="where"
      :cpntApiField="field"
      :cpntApiOrder="order"
      :cpntApiFieldVirtual="fieldVir"
      :cpntColuna="cpntColunas"
      :cpntLinha="linhas"
      :cpntBotaoExportar="exportar"
      :cpntSetarValores="appHisTabSetarLinhas"
      :cpntBuscaInicial="false"
      ref="tabela">
        <template slot="cabecalho" v-if="linhas.length >= 1 && cpntDemanda !== 'fabricacao'">
          <div style="text-align: left;">
            <!-- ({{ cpntTotais }}) -->
            <b v-if="[ '', null, undefined ].indexOf(cpntTotais) === -1 && [ '', null, undefined ].indexOf(cpntTotais.qtde_demanda) === -1">
              <span v-if="cpntDemanda === 'dem_venda__servico'">Serviço(s) | </span>
              <span v-else>Produto(s) | </span>

              <template v-if="cpntDemanda !== 'insumo'">
                Total de {{ cpntTotais.qtde_itens_count }} ite{{ Number(cpntTotais.qtde_itens_count) >= 2 ? 'ns' : 'm' }} | {{ cpntTotais.qtde_demanda }} 
              </template>
              <template v-if="cpntDemanda === 'dem_compra'"> compra{{ Number(cpntTotais.qtde_demanda) >= 2 ? 's' : '' }}</template>
              <template v-else-if="cpntDemanda === 'dem_dev_cliente'"> devoluç{{ Number(cpntTotais.qtde_demanda) >= 2 ? 'ões clientes' : 'ão cliente' }}</template>
              <template v-else-if="cpntDemanda === 'dem_dev_fornecedor'"> devoluç{{ Number(cpntTotais.qtde_demanda) >= 2 ? 'ões fornecedores' : 'ão fornecedor' }}</template>
              <template v-else-if="cpntDemanda === 'insumo'"> 
                {{ cpntTotais.cod_venda_count }} Fabricação na venda{{ Number(cpntTotais.cod_venda_count) >= 2 ? 's' : '' }} | {{ cpntTotais.id_produto_fabricado_count }} Fabricação normal  
              </template>
              <template v-else> venda{{ Number(cpntTotais.qtde_demanda) >= 2 ? 's' : '' }}</template>
            </b>
          </div>
        </template>

        <!-- COLUNA DEMANDA ID -->
        <template v-slot:col_demandaId="{ linha }">
          <App-Button @onClick='() => { appHisTabAbrirDemanda(linha.demandaId, cpntDemanda, linha) }' :cpntClass="linha._demandaBT.class">
            <span v-html="linha._demandaBT.texto"></span>
          </App-Button>
        </template>

        <!-- COLUNA ITEM -->
        <template v-slot:col_item_nome="{ linha }">
          <App-Button :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { appHisTabAbrirCadastro(linha.item, cpntDemanda) }'>
            <!-- COLOCA O NOME DO CONTATO -->
            <span v-html="linha.item_nome"></span>

            <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
            <b v-if='linha.item_status !== "1"' v-html="'[Excluído]'"></b>
          </App-Button>
        </template>

        <!-- COLUNA ULTIMA ALTERAÇÃO -->
        <template v-slot:col_last="{ linha }">
          <span>
            <span v-if="linha.last_user_usuario !== undefined" v-html="linha.last_user_usuario"></span>
            <span v-if="linha.last_user_usuario !== undefined && linha.last_at_ptbr !== undefined"><br/></span>
            <span v-if="linha.last_at_ptbr !== undefined" v-html="linha.last_at_ptbr"></span>
          </span>
        </template>

        <!-- COLUNA CONTATO -->
        <template v-slot:col_demandaId_id_con_nome="{ linha }">
          <App-Button :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { appHisTabAbrirCadastro(linha.demandaId_id_con, "contato") }'>
            <!-- COLOCA O NOME DO CONTATO -->
            <span v-html="linha.demandaId_id_con_nome"></span>

            <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
            <span v-if='linha.demandaId_id_con_pessoa === "j" && linha.demandaId_id_con_empresa !== ""' v-html="' (' + linha.demandaId_id_con_empresa + ')'"></span>

            <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
            <b v-if='linha.demandaId_id_con_status !== "1"' v-html="'[Excluído]'"></b>
          </App-Button>
        </template>
      </App-Tabela>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true,
        type: String
      },
      cpntColunas: {
        required: true
      },
      cpntLinhas: {
        required: true
      },
      cpntTotais: {
        required: true
      },
      cpntFiltros: {
        required: true,
        type: Object
      },
      cpntRpp: {
        required: false,
        type: Number,
        default: function () {
          return 20
        }
      },
      cpntTotal: {
        required: true
      },

      cpntMontarRouter: {
        required: true
      },
      cpntMontarMethod: {
        required: true
      },
      cpntMontarField: {
        required: true
      },
      cpntMontarWhere: {
        required: true
      },
      cpntMontarOrder: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        colunas: [],
        linhas: [],
        route: '',
        method: '',
        field: {},
        fieldVir: [],
        where: {},
        order: {},
        exportar: {
          format: [ 'xlsx', 'pdf' ],
          search: true,
          field: [
            { demandaId:               'Demanda Cód.'     },
            { demandaId_id_con_nome:   'Contato'          },
            { demandaId_data:          'Demanda Data'     },
            { item_codigo:             'Cód.'             },
            { item_nome:               'Nome'             },
            { qtde:                    'Qtde.'            },
            { valor_uni:               'Valor Unitário'   },
            { valor_uni_novo:          'Valor Unitário'   },
            { valor_tot_novo:          'Valor Total'      }
          ]
        }
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.appHisTabSetarStatusGeral('carregando')

      // CHAMA A FUNÇÃO PARA INICIAR O CARREGAMENTO
      this.appHisTabIniciar()
    },
    methods: {
      appHisTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appHisTabIniciar: function () {
        // CHAMA A FUNÇÃO PARA MONTAR O WHERE
        this.route = this.cpntMontarRouter(this.cpntDemanda)

        // CHAMA A FUNÇÃO PARA MONTAR O WHERE
        this.method = this.cpntMontarMethod(this.cpntDemanda)

        // CHAMA A FUNÇÃO PARA MONTAR O WHERE
        this.field = this.cpntMontarField(this.cpntDemanda)

        // CHAMA A FUNÇÃO PARA MONTAR O WHERE
        this.where = this.cpntMontarWhere(this.cpntDemanda)

        // CHAMA A FUNÇÃO PARA MONTAR O ORDER
        this.order = this.cpntMontarOrder(this.cpntDemanda)

        // SETA AS LINHAS DA TABELA
        if ([ '', null, undefined ].indexOf(this.cpntLinhas) === -1) {
          this.appHisTabSetarLinhas(this.cpntLinhas)
        }

        // CHAMA A FUNÇÃO PARA ATUALIZAR OS DADOS DA TABELA
        this.appHisTabSetarTotalRegistro()

        // SETA O STATUS DA PAGINA
        this.appHisTabSetarStatusGeral('')
      },
      appHisTabSetarLinhas: function (linhas) {
        // IMPORTA A FUNÇAO
        const CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM = require('@/assets/js/Funcoes-Gerais.js').CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM

        // INICIA O PROCESSO
        var tipo = ''

        // SETA OS IDS SOLICITADOS
        for (var index in linhas) {
          // VERIFICA O TIPO DE REGISTRO
          if ([ 'fabricacao' ].indexOf(this.cpntDemanda) !== -1) {
            // SETA O TIPO DE REGISTRO
            linhas[index].item_tipo = 'Produto'
            
            // SETA O TIPO DE REGISTRO
            tipo = 'produto'

            // SETA O STATUS DA DEMANDA
            linhas[index].demandaId_status = '2'
            
            // SETA O ID DA DEMANDA
            linhas[index].demandaId = linhas[index].id
          } else if ([ 'insumo' ].indexOf(this.cpntDemanda) !== -1) {
            // SETA O TIPO DE REGISTRO
            linhas[index].item_tipo = 'Produto'
            
            // SETA O TIPO DE REGISTRO
            tipo = 'produto'

            // SETA O STATUS DA DEMANDA
            linhas[index].demandaId_status = '2'
            
            // SETA O ID DA DEMANDA
            linhas[index].demandaId = [ '', null, undefined ].indexOf(linhas[index].cod_venda) === -1 ? linhas[index].cod_venda : linhas[index].id_produto_fabricado
          } else if ([ 'dem_compra', 'dem_dev_fornecedor', 'dem_venda__produto', 'dem_dev_cliente' ].indexOf(this.cpntDemanda) !== -1) {
            // SETA O TIPO DE REGISTRO
            linhas[index].item_tipo = 'Produto'
            
            // SETA O TIPO DE REGISTRO
            tipo = 'produto'
          } else {
            // SETA O TIPO DE REGISTRO
            linhas[index].item_tipo = 'Serviço'
            
            // SETA O TIPO DE REGISTRO
            tipo = 'servico'
          }

          // MANDA CALCULAR OS VALORES
          linhas[index] = CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM(linhas[index], tipo)

          // SETA OS DADOS DO BOTÃO
          linhas[index]._demandaBT = {
            texto: this.appHisTabMontarBotaoDemandaDocTexto(linhas[index]),
            class: (linhas[index].demandaId_status === '2' ? [ 'btn', 'btn-sm', 'btn-primary' ] : [ 'btn', 'btn-sm', 'btn-warning' ])
          }

          // CONVERTE O VALOR RECEBIDO
          if (this.cpntDemanda === 'dem_venda__servico') {
            linhas[index].valor_uni = (Number(linhas[index].valor_uni) / 100).toFixed(2)
            linhas[index].valor_tot = (Number(linhas[index].valor_tot) / 100).toFixed(2)
          }
        }

        // SETA OS VALORES RECEBIDOS
        this.linhas = linhas

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appHisTabMontarBotaoDemandaDocTexto: function (linha) {
        // FORMATA O VALOR RECEBIDO
        var valor = (linha.demandaId.length <= 4 ? ('0000' + linha.demandaId).slice(-4) : linha.demandaId)

        // PEGA A DEMANDA
        var demanda = this.cpntDemanda

        // VERIFICA O TIPO DA DEMANDA
        if (demanda === 'insumo') {
          demanda = [ '', null, undefined ].indexOf(linha.cod_venda) === -1 ? 'dem_venda__produto' : 'fabricacao'
        }

        // RETORNA O VALOR MONTADO
        switch (demanda) {
          case 'dem_venda__produto':
          case 'dem_venda__servico':
            valor = ((linha.demandaId_status === '2' ? 'V' : 'O') + ' ' + valor)
            break
        
          case 'dem_compra':
            valor = ((linha.demandaId_status === '2' ? 'C' : 'O') + ' ' + valor)
            break

          case 'dem_dev_cliente':
            valor = ('DC ' + valor)
            break

          case 'dem_dev_fornecedor':
            valor = ('DF ' + valor)
            break

          case 'fabricacao':
            valor = ('F ' + valor)
            break
        }

        // RETORNA O VALOR
        return valor
      },
      appHisTabSetarTotalRegistro: function (tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.appHisTabSetarTotalRegistro((tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.cpntTotal) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs.tabela) === true ? this.$refs.tabela[0] : this.$refs.tabela

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1) {
              // SETA A QUANTIDADE DE REGISTROS
              elemento.rpp = Number(this.cpntRpp)
              elemento.paginacao.rpp.value = this.cpntRpp.toString()

              // SETA A QUANTIDADE DE REGISTROS
              elemento.total = Number(this.cpntTotal)

              // CHAMA A FUNÇÃO PARA CALCULAR A QUANTIDADE DE REGISTROS
              elemento.cpntApiTabCalcularQtdeRegistros()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      appHisTabAbrirCadastro: function (id, tipo) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: true, tipo: tipo, id: id }

        // RETORNA O VALOR MONTADO
        switch (tipo) {
          case 'fabricacao':
          case 'insumo':
          case 'dem_compra':
          case 'dem_dev_fornecedor':
          case 'dem_venda__produto':
          case 'dem_dev_cliente':
            params.tipo = 'produto'
            break

          case 'dem_venda__servico':
            params.tipo = 'servico'
            break

          case 'contato':
            params.editar = false
            break
        }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = () => {
          // if (atualizar === true) {
          //   this.appHisTabSetarLinhas()
          // }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      appHisTabAbrirDemanda: function (demandaId, cpntDemanda, linha) {
        // INICIA A VARIAVEL
        var params = ''

        // PEGA A DEMANDA
        var demanda = this.cpntDemanda

        // VERIFICA O TIPO DA DEMANDA
        if (demanda === 'insumo') {
          demanda = [ '', null, undefined ].indexOf(linha.cod_venda) === -1 ? 'dem_venda__produto' : 'fabricacao'
        }

        // RETORNA O VALOR MONTADO
        switch (demanda) {
          case 'dem_venda__produto':
          case 'dem_venda__servico':
            params = { name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'venda', id: demandaId, tipo: 'recibo', formato: 'html' } }
            break
        
          case 'dem_compra':
            params = { name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'compra', id: demandaId, tipo: 'recibo', formato: 'html' } }
            break

          case 'dem_dev_cliente':
            params = { name: 'dev_cliente_nova_numero', params: { cts: this.$store.state.token.cts, id: demandaId } }
            break

          case 'dem_dev_fornecedor':
            params = { name: 'dev_fornecedor_nova_numero', params: { cts: this.$store.state.token.cts, id: demandaId } }
            break

          case 'fabricacao':
            params = { name: 'prod_fabricar_busc', params: { cts: this.$store.state.token.cts, id: demandaId, busca: window.btoa(JSON.stringify({ id: demandaId })) } }
            break
        }

        // ABRE O RECIBO DA DEMANDA SOLICITADO
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve(params).href, '_blank', {}, false)
      }
    },
    watch: {
      cpntRpp: function () {
        this.appHisTabSetarTotalRegistro()
      }
    }
  }
</script>
